import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { EXPERIMENT_FLAG, isExcludedSlug } from '../constants'

export const useTrackPen7395Experiment = (slug: string | undefined) => {
  const excluded = isExcludedSlug(slug)

  useEffect(() => {
    if (!excluded) {
      trackExperimentViewed(EXPERIMENT_FLAG)
    }
  }, [excluded])
}
